import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";
import { PagerService } from "../../core/services/pager.service";

@Component({
  selector: "app-source",
  templateUrl: "./source.component.html",
  styleUrls: ["./source.component.css"],
})
export class SourceComponent implements OnInit {
  DeviceTypeList;
  ErrorMessage;
  SourceList: any[];
  public country = "";
  public Type = "";
  public LoginEnterpriseID = "";
  public Country = "";
  public DeviceType;
  public Role = "";
  dataLoader: boolean;
  public successfulData: any = [];

  Device;
  Countries: any[];
  SourceDetails;
  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];

  constructor(
    private router: Router,
    private capservice: CAPService,
    private _avRoute: ActivatedRoute,
    private pagerService: PagerService
  ) {
    this.LoginEnterpriseID = capservice.enterpriseid;
    this.Role = capservice.Role;
    this.Country = capservice.country;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == undefined) {
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit(): void {
    // if(this.Role == "Regional Voice Admin"|| this.Role == "Global Admin")
    // {
    //   $("#divSourceDetails").css("display", "block");
    //   $("#AlertForAccessSource").css("display", "none");
      
    //   this.InitLoad();
    // }
    // else
    // {
    //   $("#divSourceDetails").css("display", "none");
    //   $("#AlertForAccessSource").css("display", "block");
    // }
    this.dataLoader = true;
    this.SourceDetails = {
      Country: "",
      SourceName: "",
      areaCode: "",
    };
    this.successfulData = {
      Id: "",
      Country: "",
      SourceName: "",
      areaCode: "",
    };
    this.DeviceTypeList = [{ name: "Teams" }];
    this.Device = "Teams";

    this.GetCountryList();
    this.InitLoad();
  }
  InitLoad() {
    this.capservice
      .GetVoiceAdminDetails(this.Device, "Source", this.country)
      .subscribe((data) => {
        if (data.length >= 0) {
          this.dataLoader = true;
          this.successfulData = { Sources: data, selected: {} };
          this.allItems = data;
          // initialize to page 1
          this.setPage(1);
          this.dataLoader = false;
        }
      });

    this.capservice
      .GetVoiceAdminDetails(this.Device, "SourceDropdown", this.country)
      .subscribe((data) => {
        if (data.length >= 0) {
          this.SourceList = data;
        }
      });
  }
  GetCountryList() {
    this.capservice.CountryList(this.country, this.Type).subscribe((data) => {
      this.Countries = data;
      this.dataLoader = false;
    });
  }
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.Sources = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
  clear() {
    $("#grdfSourceName").val("");
    $("#grdfareaCode").val("");
    $("#grdfCountry").val("");
    $("#grdSource").val("");
    $("#grdareaCode").val("");
    $("#grdCountry").val("");
    $("#dlstCountry").val("");
    $("#txtSourceName").val("");
    //this.DeviceTypeEvent();
    this.InitLoad();
    $("#divSourceDetails").css("display", "block");
  }
  SearchResult() {
    var Country = '';
    if (($('#txtSourceName')).val() == "" && ($('#dlstCountry')).val() == "") {
      $('#divSourceDetails').css("display", 'none');
      alert("Please select value to search");
    }
    else {
      if (this.Role != 'Global Admin') {
        Country = $('#dlstCountry').val() == '' ? this.Country : $('#dlstCountry').val();
      }
      else {
        Country = $('#dlstCountry').val() == '' ? 'N' : $('#dlstCountry').val();
      }
      var SourceName = $('#txtSourceName').val() == '' ? 'N' : $('#txtSourceName').val();

      this.capservice
        .SearchDetails(SourceName, Country, "N", this.Device, "Source")
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { Sources: data, selected: {} };
            this.allItems = data;
            // initialize to page 1
            this.setPage(1);
            $("#divSourceDetails").css("display", "block");
          } else {
            alert("No Records Found");
            $("#divSourceDetails").css("display", "none");
          }
        });
    }
  }
  EditSource(Source) {
    this.successfulData.selected = Object.assign({}, Source);
  }
  DeleteSource(Source) {
    this.capservice
      .DeleteVoiceAdminDetails(
        Source.Id,
        "Source",
        this.LoginEnterpriseID,
        null
      )
      .subscribe((data) => {
        if (data.length > 0) {
          alert("Deleted Successfully");
          this.clear();
        } else {
          alert(data);
          this.clear();
        }
      });
  }
  SourceUpdate(Source) {
    var message = '';

    if ($("#grdCountry").val() == "") {
      message = message + "\n" + "Please Select Country";
    }
    if ($("#grdSource").val() == "") {
      message = message + "\n" + "Please Enter Source";
    }
    if ($("#grdareaCode").val() == "") {
      message = message + "\n" + "Please Enter AreaCode";
    }
    if (message != "") {
      alert(message);
    } else {
      this.successfulData.selected.ID1 =
        this.successfulData.selected.Id.toString();
      this.successfulData.selected.Id = this.successfulData.selected.Id;
      this.successfulData.selected.DeviceType = this.Device;
      this.successfulData.selected.strType = "Source";
      this.successfulData.selected.EnterpriseID = this.LoginEnterpriseID;
      this.capservice
        .UpdateVoiceAdminDetails(this.successfulData.selected)
        .subscribe((data) => {
          if (data.toString() == "Failed") {
            alert("Updated Successfully");
            this.clear();
          } else {
            alert(data);
            this.clear();
          }
        });
    }
    // this.InitLoad();
  }
  SourcesAdd() {
    var message = '';

    if ($("#grdfCountry").val() == "") {
      message = message + "\n" + "Please Select Country";
    }
    if ($("#grdfSourceName").val() == "") {
      message = message + "\n" + "Please Enter Source Name";
    }
    if ($("#grdfareaCode").val() == "") {
      message = message + "\n" + "Please Enter Area Code";
    }
    if ($("input[name=radioDeviceType]:checked").next().text().trim() == "") {
      message = message + "\n" + "Please Select DeviceType";
    }
    if (message != "") {
      alert(message);
    } else {
      this.SourceDetails.DeviceType = this.Device;
      this.SourceDetails.EnterpriseID = this.LoginEnterpriseID;
      this.SourceDetails.strType = "Source";

      this.capservice
        .InsertVoiceAdminDetails(this.SourceDetails)
        .subscribe((data) => {
          if (data.toString() == "Failed") {
            alert("Inserted Successfully");
            this.clear();
          } else {
            alert(data);
            this.clear();
          }
        });
    }
    // this.InitLoad();
  }
  validateNumber(e: any) {
    let input = String.fromCharCode(e.charCode);
    const reg = /^[\d +-]+$/;

    if (!reg.test(input)) {
      e.preventDefault();
    }
  }
  GetFacility() {}
  reset() {
    this.successfulData.selected = {};
  }
}
